import React from 'react';
import { Link } from 'react-router-dom';
import { Archive, Home, Search } from 'lucide-react';
import logo from '../assets/logo.png';
function NotFoundPage() {
  return (
    <div className="min-h-screen bg-dark-bg flex flex-col items-center justify-center px-6">
      <div className="text-center">
        <div className="gradient-primary w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6">
          <Archive size={40} className="text-dark-bg" />
        </div>
        <h1 className="text-8xl font-serif font-bold text-white mb-4">404</h1>
        <p className="text-white/40 text-xl mb-2">Page non trouvée</p>
        <p className="text-white/20 text-sm mb-8">La page que vous recherchez n'existe pas ou a été déplacée.</p>
        
        <div className="flex flex-wrap gap-4 justify-center">
          <Link to="/" className="inline-flex items-center gap-2 bg-mint text-dark-bg px-6 py-3 rounded-lg font-mono text-sm hover:bg-pink transition">
            <Home size={16} /> Accueil
          </Link>
          <Link to="/browse" className="inline-flex items-center gap-2 border border-white/20 px-6 py-3 rounded-lg font-mono text-sm text-white/70 hover:border-mint hover:text-mint transition">
            <Search size={16} /> Parcourir
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;